import { createSelector } from '@reduxjs/toolkit';
import { State } from 'app/store';

export const selectReferrerState = (state: State) => state.referrer;
export const selectTotalReferrals = (state: State) => state.referrer.userReferrals.total;

export const selectUserReferrals = createSelector(selectReferrerState, (state) => state.userReferrals);
